import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Person, Policy, Extension } from "@mui/icons-material";
import { appRoutes } from "../../../constant/constant";

const MedecinMenu = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <Divider />
      <List sx={{ py: 1 }}>
        <ListItem
          disablePadding
          sx={{ borderRadius: 2, overflow: "hidden", my: 0.5 }}
        >
          <ListItemButton
            onClick={() => navigate(appRoutes.adminAssure)}
            selected={isActive(appRoutes.adminAssure)}
            sx={{
              borderRadius: 2,
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: "success.light",
                "& .MuiListItemIcon-root": {
                  color: "warning.main",
                },
              },
              "&.Mui-selected": {
                backgroundColor: "success.main",
                color: "common.white",
                "& .MuiListItemIcon-root": {
                  color: "warning.main",
                },
                "&:hover": {
                  backgroundColor: "success.dark",
                },
              },
            }}
          >
            <ListItemIcon sx={{ minWidth: 40 }}>
              <Person
                sx={{
                  color: isActive(appRoutes.adminAssure)
                    ? "warning.main"
                    : "text.secondary",
                  transition: "color 0.3s ease",
                }}
              />
            </ListItemIcon>
            <ListItemText
              primary="Assurés"
              primaryTypographyProps={{
                fontWeight: isActive(appRoutes.adminAssure) ? "bold" : "normal",
              }}
            />
          </ListItemButton>
        </ListItem>
      </List>
    </>
  );
};

export default MedecinMenu;
